/* eslint-disable */
import * as Types from '../../../../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClickInProductMessageMutationVariables = Types.Exact<{
  input: Types.ClickInProductMessageInput;
}>;

export type ClickInProductMessageMutation = {
  __typename?: 'Mutation';
  clickInProductMessage: {
    __typename?: 'BasicMutationPayload';
    success: boolean;
  };
};

export const ClickInProductMessageDocument = gql`
  mutation clickInProductMessage($input: ClickInProductMessageInput!) {
    clickInProductMessage(input: $input) {
      success
    }
  }
`;
export type ClickInProductMessageMutationFn = Apollo.MutationFunction<
  ClickInProductMessageMutation,
  ClickInProductMessageMutationVariables
>;

/**
 * __useClickInProductMessageMutation__
 *
 * To run a mutation, you first call `useClickInProductMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClickInProductMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clickInProductMessageMutation, { data, loading, error }] = useClickInProductMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClickInProductMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ClickInProductMessageMutation,
    ClickInProductMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ClickInProductMessageMutation,
    ClickInProductMessageMutationVariables
  >(ClickInProductMessageDocument, options);
}
export type ClickInProductMessageMutationHookResult = ReturnType<
  typeof useClickInProductMessageMutation
>;
export type ClickInProductMessageMutationResult =
  Apollo.MutationResult<ClickInProductMessageMutation>;
export type ClickInProductMessageMutationOptions = Apollo.BaseMutationOptions<
  ClickInProductMessageMutation,
  ClickInProductMessageMutationVariables
>;
